// Updated JavaScript with Splide.js
document.addEventListener('DOMContentLoaded', function() {
  //translations
  const TRANSLATIONS = window.searchTranslations || {};

  // Wait for images to load
  const preloadImages = () => {
    const imgs = document.querySelectorAll('.featured-collection-shots img');
    const proms = [];
    imgs.forEach((img) => {
      if (img.complete) return;
      proms.push(
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
      );
      if (img.dataset.src && !img.src) img.src = img.dataset.src;
    });
    return Promise.all(proms);
  };

  // Initialize Splide sliders after images are loaded
  const initSliders = () => {
    // 1. Initialize main shots slider
    const shotsSlider = new Splide('#shots-splide', {
      type: 'loop',
      pagination: false,
      arrows: false,
      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
      speed: 600,
      flickMaxPages: 1,
      easing: 'cubic-bezier(.7,0,.3,1)'
    }).mount();

    // 2. Initialize left products slider
    const leftSlider = new Splide('#left-splide', {
      type: 'loop',
      pagination: false,
      arrows: false,
      perPage: 2,
      gap: 8, // var(--space-sm)  
      speed: 600,
      start: shotsSlider.length - 2, 
      breakpoints: {
        767: {
          perPage: 2,
        }
      },
      drag: false,
      flickMaxPages: 1,
      easing: 'cubic-bezier(.7,0,.3,1)'
    }).mount();

    // 3. Initialize right products slider
    const rightSlider = new Splide('#right-splide', {
      type: 'loop',
      pagination: false,
      arrows: false,
      perPage: 3,
      gap: 8,
      speed: 600,
      start: 1,
      drag: false,
      flickMaxPages: 1,
      easing: 'cubic-bezier(.7,0,.3,1)',
      breakpoints: {
        767: {
          perPage: 2,
        }
      }
    }).mount();

    // 4. Sync the sliders
    shotsSlider.on('move', function() {
      let sliderIndex = shotsSlider.index;
      let totalProducts = leftSlider.length;
      let leftIndex;
      let rightIndex;
      if (sliderIndex == 3) {
        leftIndex = shotsSlider.index - 2 + totalProducts;
      } else if (sliderIndex == 2) {
        leftIndex = shotsSlider.index - 2 + totalProducts;
      } else {
        leftIndex = shotsSlider.index - 2;
      }

      if(sliderIndex == totalProducts) {
        rightIndex = 0;
      } else if (sliderIndex == totalProducts - 1 ) {
        rightIndex = shotsSlider.index + 1;
      } else if (sliderIndex == totalProducts - 2 ) {
        rightIndex = shotsSlider.index - totalProducts + 1;
      } else {
        rightIndex = shotsSlider.index + 1;
      }

      leftSlider.go(leftIndex);
      rightSlider.go(rightIndex);
    });

    // 5. Add hover effects for the "add to cart" button
    document.querySelectorAll('.featured-collection-shots__shot').forEach(shot => {
      shot.addEventListener('mouseenter', function() {
        shotsSlider.Components.Autoplay.pause();
      });
      
      shot.addEventListener('mouseleave', function() {
        shotsSlider.Components.Autoplay.play();
      });
    });

    // 6. Show the sliders after initialization
    const container = document.querySelector('.featured-collection-shots__interaction-wrapper');
    if (container) {
      container.style.opacity = '1';
    }

    // 7. Navigation arrows
    const prevButton = document.querySelector('.product-highlights__nav-button--prev');
    const nextButton = document.querySelector('.product-highlights__nav-button--next');
    
    if (prevButton && nextButton) {
      prevButton.addEventListener('click', function() {
        shotsSlider.go('<');
      });
      nextButton.addEventListener('click', function() {
        shotsSlider.go('>');
      });
    }
  };

  // Helper function for quick add to cart
  window.quickAdd = function(variantId, button) {
    // Prevent multiple clicks
    if (button.hasAttribute('disabled')) return;
    button.setAttribute('disabled', true);
    
    // Show loading state
    const originalText = button.textContent;
    button.textContent = TRANSLATIONS.product.adding || 'Adding...';
    
    // Add to cart via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count and show success message
      if (typeof updateCartCount === 'function') {
        updateCartCount();
      }
      button.textContent = TRANSLATIONS.product.added || 'Added';
      setTimeout(() => {
        button.textContent = originalText;
        button.removeAttribute('disabled');
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.textContent = TRANSLATIONS.product.try_again || 'Try again';
      setTimeout(() => {
        button.textContent = originalText;
        button.removeAttribute('disabled');
      }, 2000);
    });
  };

  // Initialize everything
  const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
  // Promise.all([preloadImages(), fontsReady]).then(() => {
  //   // Small delay to ensure everything is ready
  //   setTimeout(initSliders, 100);
  // });
  setTimeout(initSliders, 100);
});